import {useEffect} from 'react'
import {useForceUpdate} from '@containers/hooks'
import {idTasksStore} from '@extensions/id-tasks/id-tasks-store'

export const useIdTaskUpdater = (): void => {
  const forceUpdate = useForceUpdate()

  useEffect(() => {
    forceUpdate()
  }, [idTasksStore.state.modified])
}
